// extracted by mini-css-extract-plugin
export default {"PlainFeature":"wp_a bic_b"};